import { getWoundAttachmentUrl } from '../../services/api';
import type {
  WoundAttachmentResponse,
  WoundResponse,
} from '../../services/api';

/**
 * Open a wound attachment in a new tab. On failure, log the error and show
 * `failureMessage` through `showError`.
 */
export async function openWoundAttachment(
  wound: Pick<WoundResponse, 'id' | 'patient_id'>,
  attachment: Pick<WoundAttachmentResponse, 'id'>,
  showError: (message: string) => void,
  failureMessage: string
): Promise<void> {
  try {
    const resp = await getWoundAttachmentUrl({
      path: {
        patient_id: wound.patient_id,
        wound_id: wound.id,
        attachment_id: attachment.id,
      },
    });
    const url = (resp.data as { url?: string } | undefined)?.url;
    if (resp.error || !url) throw resp.error ?? new Error('No download URL');
    window.open(url, '_blank');
  } catch (error) {
    console.error('Failed to download wound attachment:', error);
    showError(failureMessage);
  }
}
